export default __webpack_public_path__ + "static/media/flag17.496e27cc.jpg";